export default "__VITE_ASSET__rynv4ruH__"